import React from 'react';

import { connect } from 'react-redux';

import cityChange from '../../../lib/actions/cityChange';
import { validationsSelector } from '../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../lib/selectors/amortization-calculator-selector';
import {
  INPUT_TRACKING_TYPES,
  debouncedTrackOnChange,
  AmortizationInput,
} from '../../../lib/utils';
import LocationAutoComplete from '../../location-autocomplete/location-autocomplete';

const PropertyLocation: React.FC<AmortizationInput> = ({
  manualInputs,
  inputs,
  dispatch,
  label,
  analytics,
}) => {
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (value) => {
    const { city, zip } = value;
    const trackingValue = `${city}${zip ? ` (${zip})` : ''}`;

    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'LocationAutoComplete',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
      };
    }

    debouncedTrackOnChange({
      legacy,
      bedrock,
      validation: { valid: true },
      value: trackingValue,
    });

    dispatch(cityChange(value, 'purchaseAddress'));
  };

  return (
    <LocationAutoComplete
      data={manualInputs}
      enableTracking={false}
      label={label}
      key="mc-location-autocomplete"
      onChange={onInputChange}
      placeholder={`${inputs?.purchaseAddress?.city}, ${inputs?.purchaseAddress?.state}`}
      trackingFormName="controlPanel"
    />
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(PropertyLocation);
